import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpMainService } from "../http-main.service";
import { ClientPerformanceResponseModel, CommissionsCurrentIntroducerResponseModel, ListModel } from '@itb-monorepo/models';
import { ClientCommissionResponseModel } from '@itb-monorepo/models';
import { DepositReportResponse } from '@itb-monorepo/models';
import { DepositSumResponseModel } from '@itb-monorepo/models';



@Injectable()
export class CommissionsService {
  baseUrl = '/trade/';
  private _HttpMainService = inject(HttpMainService);

  getCurrentCommission(
    startDate: string,
    ibId = 'current'
  ): Observable<CommissionsCurrentIntroducerResponseModel> {
    return this._HttpMainService.get<CommissionsCurrentIntroducerResponseModel>(
      `${this.baseUrl}v1/introducers/${ibId}/commissions/${startDate}`
    ).pipe(
      map((commission) => ({
        ...commission,
        // MET-1089 renamed the totals; preserve existing commission consumers.
        active_client: commission.total_active_client ?? commission.active_client ?? 0,
        active_client_lot: commission.total_active_client_lot ?? commission.active_client_lot ?? 0,
      }))
    );
  }
  getCurrentClientDetails(
    client_user_id: string,
    ibId: string
  ): Observable<CommissionsCurrentIntroducerResponseModel> {
    return this._HttpMainService.get(
      this.baseUrl +
        `v1/introducers/${ibId}/clients/${client_user_id}/commissions/current`
    );
  }
  getClientPerformance(
    ibId: string,
    month: string
  ): Observable<ClientPerformanceResponseModel> {
    return this._HttpMainService.get(
      this.baseUrl + `v1/introducers/${ibId}/commissions/${month}/performance`
    );
  }
  getCurrentCommissionsList(
    introducer_user_id: string,
    params: any
  ): Observable<ListModel<CommissionsCurrentIntroducerResponseModel>> {
    return this._HttpMainService.get(
      this.baseUrl + `v1/introducers/${introducer_user_id}/commissions`,
      params
    );
  }
  getDepositReport(
    introducer_user_id: string,
    params: any
  ): Observable<ListModel<DepositReportResponse>> {
    return this._HttpMainService.get(
      `/report/v1/introducers/${introducer_user_id}/deposits`,
      params
    );
  }
  getTotalDepositsSum(
    introducer_user_id: string,
    month: string,
    params: any
  ): Observable<DepositSumResponseModel> {
    return this._HttpMainService.get(
      `/report/v1/introducers/${introducer_user_id}/deposits/${month}/sum`,
      params
    );
  }
  getCommissionListIb(
    params: any,
    ibId = 'current'
  ): Observable<ListModel<ClientCommissionResponseModel>> {
    const filters: string[] = [];

    if (params.registered_at) {
      filters.push(params.registered_at);
    }

    if (params.group_by === 'active') {
      filters.push('is_active_client:eq(true)');
    }

    if (params.group_by === 'inactive') {
      filters.push('is_active_client:eq(false)');
    }

    const queryParams: any = {
      take: params.take,
      skip: params.skip,
      filter: filters.join(','),
    };

    if (params.search) {
      queryParams.search = params.search;
    }

    return this._HttpMainService.get(
      `${this.baseUrl}v1/introducers/${ibId}/clients`,
      queryParams
    );
  }
  getCommissionListIbExcel(
    params: any,
    ibId = 'current'
  ): Observable<any> {
    const filters: string[] = [];
    const url = `${this.baseUrl}v1/introducers/${ibId}/clients`;

    if (params.registered_at) {
      filters.push(params.registered_at);
    }

    if (params.group_by === 'active') {
      filters.push('is_active_client:eq(true)');
    }

    if (params.group_by === 'inactive') {
      filters.push('is_active_client:eq(false)');
    }

    const queryParams: any = {
      take: params.take,
      skip: params.skip,
      filter: filters.join(','),
    };

    if (params.search) {
      queryParams.search = params.search;
    }

    return this._HttpMainService.getFile(url, 'application/csv', queryParams);
  }
  commissionWithdraw(
    commissionId: string
  ): Observable<CommissionsCurrentIntroducerResponseModel> {
    return this._HttpMainService.post(
      `${this.baseUrl}v1/commissions/${commissionId}`
    );
  }
}
